module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsSAAALEgHS3X78AAABSUlEQVRYw8WWfXGEMBTEF+YEIAEHRQISKgEJSKgEJOQcIIE6ACdxsP0nd82k+SIP0p1hYJiE/RHeI9uQxMUazXkHoJOjSV5x9CQV/2ojOcbmXmE+kNSMa7oLIMf8peEOgJX5Wn3PaIRF2AHYAHxkjm/cG22h6ae51qbqj5MdUtwFHcndU1j2/Zh6SQ34TGZnjIqYa2kRhgpOZUIoCYBKLG0KQpsVLAJQmW0WgtChf0AOgOI5KedNp5h5CmBmmfbQcp8BmCjTLgGQmkc3nxRAVXMXYKxt7gLsQvOlZEe1d0PJtvgEMJVMbC/IgMXmLsBR29wF0CfnfkvNAeBRCHBYocQOKkPm/N/IblXkl+BX253sovczWot+Md809eZjwecKh0RPKJ0NUG+Ol1YA6krzEEBVPZKp9R5tvlS8sJ7e6al1WgO1V+Dfa+AH9izk6ahu+bwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/data_edit.png
// module id = Drld
// module chunks = 1 2 3 4 5 6 8 12 14